import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getCMSSiteList, saveSiteContent, removeCMSSiteContent } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { EditorState, convertToRaw, convertFromHTML, convertFromRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

class cmsSiteContents extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              cmssiteList: [],
              openedAdd:false,
              consigne:'',
              editorState: EditorState.createEmpty()
        };

        this.getList();
    }

    openAddBox= () => {

      this.setState({openedAdd:!this.state.openedAdd});
    }

    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_cms', function () {
        var delete_id = $(this).data("id");

        if(confirm("Are your sure?")=== true){

          THIS.deleteCMSContent(delete_id);
        }

      });


    }

    deleteCMSContent = (delete_id) => {


      let ins = JSON.stringify({
        delete_id: delete_id
      });
      removeCMSSiteContent(ins).then((res) => {
          if(res.status==1){

                alert(res.message);
                this.getList();

          }else{
                alert(res.message);
          }
      });


    }

    getList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        location: this.state.location
      });
      getCMSSiteList(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            cmssiteList: res.data
            
          });
        } else {
          this.setState({
            cmssiteList: [],
          });
        }
      });
    }    

    saveSiteContent = ()=>{
        
        let req = JSON.stringify({
            name:this.state.name,
            site_content:this.state.site_content,  
            type:this.state.type,
            order:this.state.order
        })

        saveSiteContent(req).then((response) => {
          
          if(response.status==1){

                alert(response.message);
                this.getList();

          }else{
                alert(response.message);
          }
      
        });
     

    }

    handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
    };



    onChange = (editorState) => {
      //const contentState = editorState.getCurrentContent();
      //console.log("plain text", editorState.getCurrentContent().getPlainText());

      const contentState = draftToHtml(convertToRaw(editorState.getCurrentContent()))

      console.log("html", contentState);
      //const raw = convertToRaw(contentState);
      this.setState({
        consigne:editorState,
        site_content:contentState
      });
    }


    render() {

        const { cmssiteList,consigne, editorState } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">WebSite General Text Contents</h4>
                 
 
                  <div class="float-right"><button class="btn btn-primary btn-sm" onClick={this.openAddBox}>Add New</button></div>
                 
                  {this.state.openedAdd &&
                    <form>
                     <div class="row col-lg-12">
                      <div class="form-group">
                        
                        <div class="form-row">
                          
                           <div class="form-group col-md-3">
                          <label> Name <span className="astrick">*</span></label>
                         </div>
                         <div class="form-group col-md-9">
                          <input type="text" class="form-control" name="name" onChange={this.handleChange} />
                         </div>

                        </div>

                        <div class="form-row">
                          
                          <div class="form-group col-md-3">
                          <label> Content <span className="astrick">*</span></label>
                         </div>

                          <div class="form-group col-md-9">
                           
                           <Editor
                                  //defaultEditorState={editorState}
                                  value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
                                  editorState={consigne}
                                  toolbarClassName="toolbarClassName"
                                  wrapperClassName="wrapperClassName"
                                  editorClassName="editorClassName"
                                  onEditorStateChange={this.onChange.bind(this)}
                                  //onEditorStateChange={(consigne) => {this.setState({consigne})}}
                          />
                          </div>

                        </div>

                        <div class="form-row">
                          
                          <div class="form-group col-md-3">
                          <label>Type</label>
                          </div>
                          <div class="form-group col-md-9">
                          <select name="type" class="form-control" onChange={this.handleChange}>
                            
                            <option value="ticker">Ticker</option>
                            <option value="text">Only a Static Text</option>
                            <option value="notification">Notification</option>
                            <option value="comingsoon">comingsoon</option>
                            <option value="warning">Warning</option>

                          </select>
                          </div>

                        </div>

                        <div class="form-row">
                          
                          <div class="form-group col-md-3">
                          <label>Order</label>
                          </div>
                          <div class="form-group col-md-9">
                          <input type="text" class="form-control" name="order" onChange={this.handleChange} />
                          </div>
                        </div>

                       <div class="form-group row">
                          <div class="col-sm-10">
                            <button type="button" onClick={this.saveSiteContent} class="btn btn-primary btn-sm">Save</button>
                          </div>
                        </div>
                         
                      </div>

                     </div>

                     
                    </form>
                  }


                  <div class="table-responsive pt-3">
                    <table id="tablebw">
                      <thead  class="thead-dark">
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                          <th>
                            <strong>Name</strong>
                          </th>
                           
                          <th>
                            <strong>Type</strong>
                          </th>
                                                                          
                          <th>
                            <strong>Status</strong>
                          </th>

                           <th>
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {cmssiteList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                          {i+1}
                          </td>
                          <td>
                           {item.name}
                          </td>
                          
                          <td>
                            {item.type}
                          </td>
                           
                          <td dangerouslySetInnerHTML={{__html: item.status}} />
                                                       
                          <td dangerouslySetInnerHTML={{__html: item.action}} />
                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default cmsSiteContents;


// WEBPACK FOOTER //
// ./src/components/bewise/cmsSiteContents.jsx